'use client'

import type { ServerDataModalProps } from "./Types"
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from "@heroui/modal"
import { Button } from "@heroui/button"
import { Code } from "@heroui/code"
import { Divider } from "@heroui/divider";
import Link from "next/link"

export default function ServerDataModal({
  isOpen,
  onOpenChange
}: Readonly<ServerDataModalProps>) {
  return (
    <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">Minecraft Server Daten</ModalHeader>
              <ModalBody>
                <p className="text-sm">
                  Zugang zum Server haben nur eingetragene Spieler (whitelisting). Meldet euch bei Sascha, falls eure Annmeldung nicht funktioniert.
                </p>
                <p className="text-sm">
                  Nur eingetragene Spielen kommen auf den Server.
                </p>
                <Divider className="my-5" />
                <p className="text-sm">
                  Java Edition - Server Adressen (Port: 25565):
                </p>
                <Code className="text-amber-500">
                  host.mc.hllg.de:25565
                </Code>
                <Divider className="my-5" />
                <p className="text-sm">
                  Bedrock Edition - Server Adressen (Port: 19132):
                </p>
                <Code className="text-amber-500">
                  host.mc.hllg.de:19132
                </Code>
                <p className="text-sm">
                  Wichtig: Auf der PlayStation, Xbox und Nintendo Switch könnt ihr nicht direkt auf den Server. Es bedarf eines Tricks. Aktueller Stand mit der gut funktionierenden <Link href="https://github.com/Pugmatt/BedrockConnect?tab=readme-ov-file#dns-method" target="_blank" className="text-sky-500">DNS-Methode</Link>.
                </p>
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onPress={onClose}>
                  Schließen
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
    </Modal>
  )
}
